<template>
  <div class="bar-progress" :style="width"></div>
</template>

<script>
  export default {
    data() {
      return {
        totalSteps: 7,
      }
    },
    computed: {
      current() {
        return this.$store.state.barProgress;
      },
      width() {
        const perc = (this.current * 100) / this.totalSteps
        return `width: ${perc}%`
      }
    }
  }
</script>

<style scoped>
  .bar-progress {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background-color: white;
    display: block;
    z-index: 9999;
    transition: width .5s ease;
  }
</style>



// WEBPACK FOOTER //
// src/components/BarProgress.vue